import React, { forwardRef } from 'react';
import styles from './form-layout.module.css';
import classNames from 'classnames';

// Extend the props to include all input attributes
// interface FormLayoutProps extends React.HTMLAttributes<HTMLDivElement> {}

export const FormLayout = forwardRef<
  HTMLInputElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, children, ...props }, ref) => {
  return (
    <div
      className={classNames(className, styles.formLayout)}
      {...props}
      ref={ref}
    >
      {children}
    </div>
  );
});
